import { render, staticRenderFns } from "./brick_api_output.vue?vue&type=template&id=71e1e454&"
import script from "./brick_api_output.vue?vue&type=script&lang=js&"
export * from "./brick_api_output.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports